/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Chat_Context_Used_DetailInputs */



/**
* | output |
* | --- |
* | "{used} / {limit} tokens" |
*
* @param {Chat_Context_Used_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_context_used_detail = /** @type {((inputs: Chat_Context_Used_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Context_Used_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} Tokens`)
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} tokens`)
});